module.exports = __webpack_public_path__ + "static/img/simpleui_projector.bce0c62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/simpleui_projector.png
// module id = ZQKr
// module chunks = 3